import { Navigate } from 'react-router-dom'
import { useAuthStore } from '../stores/authStore'

export default function ProtectedRoute({ path, children }) {
  const { user, canManageUsers } = useAuthStore()

  const pathToKey = {
    '/pages': 'pages',
    '/posts': 'posts',
    '/categories': 'categories',
    '/media': 'media',
    '/block-types': 'block-types',
    '/navigations': 'navigations',
    '/languages': 'languages',
    '/users': 'users',
    '/settings': 'settings',
  }

  const menuKey = pathToKey[path]

  if (menuKey === 'settings') {
    return children
  }

  if (menuKey === 'users') {
    if (!canManageUsers()) {
      return <Navigate to="/dashboard" replace />
    }
    return children
  }

  const menuPermissions = user?.menu_permissions || []

  if (menuPermissions.length > 0 && !menuPermissions.includes(menuKey)) {
    return <Navigate to="/dashboard" replace />
  }

  return children
}
